import { render } from "./RegistrLayout.vue?vue&type=template&id=2d5ce5fa"
import script from "./RegistrLayout.vue?vue&type=script&lang=js"
export * from "./RegistrLayout.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Лейла\\Desktop\\azbcrm\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__